<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="source-bank">
    <common-table
      url="/api/cardManage/queryCardSourceByPage"
      deleteUrl="/api/cardManage/deleteCardSourceById"
      :column="column"
      :operate="operate"
      ref="table"
      :searchForm="searchForm"
      :searchButtons="buttons"
    >
      <template v-slot:isWork="scope">
        <el-switch
          v-model="scope.row.isWork == '1'"
          active-color="#13ce66"
          inactive-color="#ff4949"
          @change="isWorkChange(scope.row)">
        </el-switch>
      </template>
      <template v-slot:image="scope">
        <img :src="scope.row.image" style="height: 40px"/>
      </template>
    </common-table>
    <submit-form
      :title="formTitle"
      :visible.sync="formVisible"
      :formData="formData"
      :items="items"
      :rules="rules"
      :action="action"
      addUrl="/api/cardManage/insertCardSource"
      updateUrl="/api/cardManage/updateCardSource"
      :onSubmitCallback="onSubmitCallback"
      :handleClose="handleClose"
    ></submit-form>
  </div>
</template>

<script>
  import utils from '../utils/utils'
    export default {
        name: "source-bank",
      data(){
          return{
            formTitle:"",
            formVisible:false,
            formData:{
              sortFlag:0,
              sourceName:"",
              image:""
            },
            items:[{
              key:"sourceName",
              name:"sourceName",
              label:"来源名称",
              type:"input",
              prop:"sourceName"
            },{
              key:"image",
              name:"image",
              label:"图片",
              type:"uploadAuto",
              fileImageList:[],
              prop:"image"
            },{
              key:"sortFlag",
              name:"sortFlag",
              label:"排序",
              type:"number"
            }],
            rules:{
              sourceName:[{required: true, message: '请输入来源名称', trigger: 'blur'}],
              image:[{required: true, message: '请选择图片', trigger: 'change'}],
            },
            action:"",

            column:[{
              prop:"sortFlag",
              label:"排序"
            },{
              prop:"sourceName",
              label:"来源名称"
            },{
              prop:"image",
              label:"来源LOGO",
              template:"image"
            },{
              prop:"isWork",
              label:"生效",
              template:"isWork"
            }],
            operate:[{
              key:"edit",
              name:"编辑",
              handleClick:this.editRow
            },{
              key:"delete",
              name:"删除"
            }],
            searchForm:{
            },
            buttons:[{
              key:"add",
              name:"新增",
              handleClick:this.onCreate
            }]
          }
      },
      methods:{
        editRow(row){
          this.formTitle = "编辑来源";
          this.formVisible = true;
          this.action = "update";
          this.formData = {
            sortFlag:row.sortFlag,
            sourceName:row.sourceName,
            image:row.image,
            id:row.id
          }
          this.items[1].fileImageList = [{url:row.image}]
        },
        isWorkChange(row){
          let formDate = new FormData();
          formDate.append("id",row.id)
          formDate.append("isWork",row.isWork === "1" ? "0":"1")
          utils.axiosMethods({
            method:"POST",
            data:{
              id:row.id,
              isWork:row.isWork === "1" ? "0":"1"
            },
            url:"/api/cardManage/updateCardSource",
            callback:(res => {
              if(res.data.code == 0){
                if(typeof this.onSubmitCallback == "function"){
                  this.$refs['table'].getData();
                }
                this.$message.success("操作成功");
              }else{
                this.$message.error(res.data.msg);
              }
            }),
            catch:(error => {
              this.$message.error(error.response.data.message)
            })
          })
        },
        onCreate(){
          this.formTitle = "新增来源";
          this.formVisible = true;
          this.action = "add";
        },
        onSubmitCallback(){
          this.$refs['table'].getData();
        },
        handleClose(){
          this.formData = {
            sortFlag:0,
            sourceName:"",
            image:""
          }
          this.items[1].fileImageList = []
        }
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sourceBank.vue